import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { API_BASE_URL } from '../infra/apiConfig';
import logo from '../img/logoAcs2.png'; // opcional

const LoginPage = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, data);
      localStorage.setItem('token', response.data.token);
      navigate('/inscricao');
    } catch (error) {
      console.error("Erro no login:", error);
      if (error.response && error.response.status === 401) {
        alert('Usuário ou senha inválidos.');
      } else {
        alert('Não foi possível fazer o login. Verifique sua conexão ou tente novamente mais tarde.');
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-lg flex flex-col items-center">
        
        {/* Logo opcional */}
        <img
          src={logo}
          alt="Logo"
          className="w-24 h-24 object-contain mb-4"
        />

        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Entrar na sua conta
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Ou{' '}
            <Link to="/cadastro" className="font-medium text-blue-600 hover:text-blue-500">
              crie uma nova conta
            </Link>
          </p>
        </div>

        <form className="space-y-6 w-full" onSubmit={handleSubmit(onSubmit)}>
          {/* Usuário */}
          <div>
            <label htmlFor="usuario" className="block text-sm font-medium text-gray-700">
              Usuário
            </label>
            <input
              id="usuario"
              type="text"
              autoComplete="username"
              className={`mt-1 w-full p-2 border ${errors.usuario ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`}
              {...register("usuario", { required: "O nome de usuário é obrigatório." })}
            />
            {errors.usuario && <p className="mt-1 text-sm text-red-600">{errors.usuario.message}</p>}
          </div>

          {/* Senha */}
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Senha
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              className={`mt-1 w-full p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500`}
              {...register("password", { required: "A senha é obrigatória." })}
            />
            {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password.message}</p>}
          </div>

          {/* Botão */}
          <button
            type="submit"
            className="w-full py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Entrar
          </button>

          {/* Link: Esqueci minha senha */}
          <div className="mt-3 text-center">
            <Link to="/recuperar-senha" className="text-sm text-blue-600 hover:text-blue-500">
              Esqueci minha senha
            </Link>
          </div>

          {/* 🔗 Link do Drive */}
          <div className="mt-2 text-center">
            <a
              href="https://drive.google.com/file/d/14JQGW00sqFgErxqVByobf1UEE7_z1Hsd/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:text-blue-500"
            >
              Manual do Participante – Prêmio Inovação e Tecnologia
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
